import React, { Component } from "react";
import { Components } from "@webtech/webtech-ui-react/build/webtech-ui";

export interface SelectProps {
    field?: any;
    form?: any;
    items?: {
        label: any;
        value: any;
        selected?: boolean;
        [key: string]: any;
    }[];
    givenid?: string;
    exclusive?: boolean;
    columnClass?: string;
    selectedClass?: string;
    notSelectedClass?: string;
    onChange: (e) => void;
}

export default class BaseButtonSelector extends Component<SelectProps, {}> {
    onChangeHandler = e => {
        if (this.props.exclusive && e != undefined && e.length > 0) {
            this.props.form.setFieldValue(this.props.field.name, e[0]);
        } else {
            this.props.form.setFieldValue(this.props.field.name, e);
        }
    };

    render() {
        const value =
            this.props.field.value !== null &&
            !Array.isArray(this.props.field.value)
                ? [this.props.field.value]
                : this.props.field.value;
        return (
            <div id={this.props.givenid + "ButtonSelector"}>
                <Components.ButtonSelector
                    value={value}
                    items={this.props.items}
                    onChange={this.onChangeHandler}
                    columnClass={this.props.columnClass}
                    exclusive={this.props.exclusive}
                    selectedClass={this.props.selectedClass}
                    notSelectedClass={this.props.notSelectedClass}
                />
            </div>
        );
    }
}
